/* istanbul ignore file */
export { default } from './PersistStatusConsumer';
